import { string, bool, func, number } from 'prop-types'
import { PureComponent, createRef } from 'react'
import TextInput from '../../Inputs/Input'
import { kuiperClassNames } from '../../utils'
import Cell from '../Cell'

import './styles.scss'

class TextCell extends PureComponent {
  static propTypes = {
    className: string,
    editable: bool,
    entityId: string,
    entityType: string,
    getCellContents: func,
    getLeftSlot: func,
    getRightSlot: func,
    getMaxLength: func,
    onCellBlur: func.isRequired,
    onInputBlur: func,
    rowType: string,
    title: string,
    width: number,
  }

  static defaultProps = {
    getLeftSlot: () => {},
    getRightSlot: () => {},
    getMaxLength: () => undefined,
    onInputBlur: () => {},
  }

  constructor(props) {
    super(props)
    this.state = {
      content: props.getCellContents(this.props),
    }
    this.textInput = createRef()
    this.maxLength = props.getMaxLength({
      entityType: props.entityType,
    })
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    // If the cell content was empty when this component initialized, let the state
    // get set again with new data coming in.
    if (this.state.content !== null) return
    this.setState({ content: this.props.getCellContents(nextProps) })
  }

  setContent = (content) => this.setState({ content })

  saveContent = () => {
    if (
      (!this.state.content && !this.props.getCellContents(this.props)) ||
      this.state.content === this.props.getCellContents(this.props)
    ) {
      return this.setState({ content: this.props.getCellContents(this.props) })
    }

    return this.props.onInputBlur(
      this.props.entityId,
      this.state.content,
      this.props.entityType
    )
  }

  focusTextInputFromCell = () => {
    if (this.textInput.current) this.textInput.current.focus()
  }

  get contents() {
    const editableEntity = ['content', 'moment', 'story'].includes(
      this.props.entityType
    )
    if (
      (this.props.rowType === 'group' && !editableEntity) ||
      !this.props.editable
    ) {
      return this.props.getCellContents(this.props)
    }

    return (
      <TextInput
        ariaLabel={this.props.title}
        className={kuiperClassNames('name-cell')}
        maxLength={this.maxLength}
        strict={this.maxLength != null}
        onBlur={this.saveContent}
        onChange={this.setContent}
        ref={this.textInput}
        theme="white"
        value={this.state.content}
      />
    )
  }

  render() {
    const { className, getLeftSlot, getRightSlot, width } = this.props

    return (
      <Cell
        {...this.props}
        onBlur={this.props.onCellBlur}
        className={kuiperClassNames('text-cell', className)}
        leftSlot={getLeftSlot(this.props)}
        onClick={this.focusTextInputFromCell}
        rightSlot={getRightSlot(this.props)}
        width={width}
      >
        {this.contents}
      </Cell>
    )
  }
}

export default TextCell
